module.exports = global["jQuery"] = require("-!/usr/src/app/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = 1
// module chunks = 1 2 3 5 7 8